<template>
  <ListComponent title="ADR Classes" :totalCount="totalItems">
    <template #list>
      <v-row class="ma-0">
        <v-col cols="4" class="px-0 pt-0 pb-2">
          <v-text-field
            label="Search"
            outlined
            dense
            append-icon="mdi-magnify"
            clearable
            hide-details="auto"
            v-model="filters.search"
            @input="searchADR"
          ></v-text-field>
        </v-col>

        <v-col
          v-if="totalItems > 0"
          cols="8"
          class="px-0 pt-0 pb-2 d-flex justify-end"
        >
          <Pagination
            :pageNo="pageNo"
            :totalItems="totalItems"
            :pageSize="itemsPerPage"
            @itemsPerPageChange="itemsPerPageChanged"
            @prevPage="prevPage"
            @nextPage="nextPage"
          />
        </v-col>

        <v-col cols="12" class="pa-0">
          <AgGridVue
            style="width: 100%; height: calc(100vh - 172px)"
            class="ag-theme-alpine"
            id="myGrid"
            :columnDefs="headers"
            :context="context"
            @grid-ready="onGridReady"
            :defaultColDef="defaultColDef"
            :grid-options="gridOptions"
            :suppressDragLeaveHidesColumns="true"
            :rowData="allRowList"
          ></AgGridVue>
        </v-col>
      </v-row>
    </template>

    <template #dialogs>
      <ADRClassForm
        v-if="permissions && (permissions.add || permissions.change)"
        v-model="showADRClassForm"
        :editMode="isEditing"
        :editADRClassID="editADRClassID"
        @refreshList="itemsPerPageChanged(20)"
      />
      <RemarksDialog
        v-model="showRemarksForm"
        fieldKey="remarks"
        :formDetails="adrClassRemark"
        :isRequiredRemarks="true"
        @submitRemarks="activateDeactivateADRclassResult"
      />
    </template>

    <template #actions>
      <v-btn
        v-if="permissions && permissions.add"
        color="primary"
        depressed
        @click="addADRClass"
      >
        <v-icon>mdi-plus</v-icon>
        <span>Add ADR Class</span>
      </v-btn>
    </template>
  </ListComponent>
</template>

<script>
import ListComponent from "@/components/General/ListComponent.vue";
import { AgGridVue } from "ag-grid-vue";
import Pagination from "@/components/General/Pagination.vue";
import ADRClassButton from "@/components/AgGridComponents/ADRClassButton.vue";
import CustomHeader from "@/components/AgGridComponents/General/CustomHeader.vue";
import ADRClassForm from "@/components/ModuleBased/dialogForms/ADRClassForm.vue";
import RemarksDialog from "@/components/ModuleBased/dialogs/RemarksDialog.vue";


import {
  isAuthenticated,
  hasRouteAccess,
  getPermissions,
} from "@/utils/functions";

export default {
  components: {
    ListComponent,
    AgGridVue,
    Pagination,
    ADRClassButton,
    agColumnHeader: CustomHeader,
    ADRClassForm,
    RemarksDialog,
  },
  data() {
    return {
      sorting: {},
      headers: [
        {
          headerName: "ADR No.",
          field: "adr_no",
          sortable: true,
        },
        {
          headerName: "ADR Description",
          field: "adr_description",
        },
        {
          headerName: "Is Active",
          field: "is_active",
          sortable: true,
        },


        {
          headerName: "Actions",
          field: "actions",
          cellRendererFramework: "ADRClassButton",
          pinned: "right",
          width: 90,
        },
      ],
      allRowList: [],
      permissions: null,

      // pagination vars
      pageNo: 1,
      itemsPerPage: 20,
      totalItems: 0,
      filters: {},

      // ag-grid vars
      gridApi: null,
      gridColumnApi: null,
      defaultColDef: {
        resizable: true,
      },
      gridOptions: {
        onGridSizeChanged: () => {
          this.gridOptions.api.sizeColumnsToFit();
        },
        suppressRowClickSelection: true,
        suppressDragLeaveHidesColumns: true,
        enableCellTextSelection: true,
        tooltipShowDelay: 0,
        rowHeight: 35,
      },

      //ADRClass form
      showADRClassForm: false,
      isEditing: false,
      editADRClassID: null,
      adrClassRemark:{},
      adrClassStatus: null,
      adrClassId: null,
      adrClassRemark: {},
      showRemarksForm: false,
    };
  },
  computed: {
    context() {
      return { parentComponent: this };
    },
    currentProfile() {
      if (JSON.parse(localStorage.getItem("userProfile"))) {
        return JSON.parse(localStorage.getItem("userProfile"));
      } else {
        return null;
      }
    },
    offset() {
      return this.itemsPerPage * (this.pageNo - 1);
    },
  },
  methods: {
    applyGridSort(key, type) {
      if (this.filters && !this.filters.ordering) {
        this.filters.ordering = [];
      }

      if (type == null) {
        delete this.sorting[key];
        this.filters.ordering.splice(
          this.filters.ordering.indexOf(`-${key}`),
          1
        );
      } else if (type == "asc") {
        this.filters.ordering.push(key);
      } else if (type == "desc") {
        this.filters.ordering.splice(
          this.filters.ordering.indexOf(key),
          1,
          `-${key}`
        );
      }
      if (this.filters.ordering.length == 0) {
        delete this.filters.ordering;
      }
      this.itemsPerPageChanged(20);
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    searchADR() {
      this.pageNo = 1;
      this.getADRClassList();
    },
    itemsPerPageChanged(e) {
      this.pageNo = 1;
      this.itemsPerPage = e;
      this.getADRClassList();
    },
    prevPage() {
      this.pageNo--;
      this.getADRClassList();
    },
    nextPage() {
      this.pageNo++;
      this.getADRClassList();
    },
    getADRClassList(params = {}) {
      this.$bus.$emit("showLoader", true);
      params = {
        offset: this.offset,
        limit: this.itemsPerPage,
        ...params,
        ...this.filters,
      };
      if ("ordering" in params && params.ordering.length > 0) {
        params = { ...params, ordering: params.ordering.join(",") };
      }
      this.$api.adrClass
        .getADRClassList(params)
        .then((res) => {
          this.allRowList = res.data;
          this.totalItems = res.count;
          this.$bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          this.$bus.$emit("showLoader", false);
        });
    },
    activateDeactivateADRclassResult() {
      this.$bus.$emit("showLoader", true);
      let payload = {
        id: this.adrClassId,
        adrClass_remarks: this.adrClassRemark.remarks,
        adrClass_status: this.adrClassStatus,
      };
      this.$api.adrClass
        .activateDeactivateadrClass(payload)
        .then((res) => {
          this.getADRClassList();
          this.$bus.$emit("showToastMessage", {
            message: "ADRClass Updated successfully!",
            color: "success",
          });
          this.showRemarksForm = false;
          this.$bus.$emit("showLoader", false);
          delete this.adrClassRemark.remarks;
        })
        .catch((err) => {
          this.formErrors = err.data;
          console.error(err);
          this.$bus.$emit("showToastMessage", {
            message: `${
              err.data && err.data.non_field_errors
                ? err.data.non_field_errors.join()
                : "Couldn't update adrclass status!"
            }`,
            color: "error",
          });
          this.$bus.$emit("showLoader", false);
        });
    },
    adrClassActivateDeactivate(id,status){
     this.adrClassStatus = status;
     this.adrClassId = id;
      if (status == "deactivate") {
        delete this.adrClassRemark.remarks;
        this.showRemarksForm = true;
      } else {
        this.activateDeactivateADRclassResult();
    }
    },
    addADRClass() {
      this.editADRClassID = null;
      this.isEditing = false;
      this.showADRClassForm = true;
    },
    editADRClass(id) {
      this.editADRClassID = id;
      this.isEditing = true;
      this.showADRClassForm = true;
    },
  },
  beforeMount() {
    if (!isAuthenticated()) {
      this.$router.push("/");
    } else if (!hasRouteAccess(this.$route)) {
      this.$router.push(`/${localStorage.getItem("user_type").toLowerCase()}`);
    } else {
      const permissions = getPermissions("configuration");
      if (!permissions || !permissions.view) {
        this.$bus.$emit("showToastMessage", {
          message: "You don't have access to this page",
          color: "error",
        });
        this.$router.push(
          `/app/${
            localStorage.getItem("user_type")
              ? localStorage.getItem("user_type").toLowerCase()
              : "error"
          }`
        );
      } else {
        this.permissions = { ...permissions };
        this.getADRClassList();
      }
    }
  },
};
</script>
